"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebaseTimestampToDate = void 0;
function firebaseTimestampToDate(timestamp) {
    if (timestamp && 'toDate' in timestamp) {
        return timestamp.toDate();
    }
    return timestamp;
}
exports.firebaseTimestampToDate = firebaseTimestampToDate;
